import { VerticalContainer } from '@american-autonomy/ag-ui';

import BodyText from 'components/text/BodyText';
import CaptionText from 'components/text/CaptionText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ChemicalDetailCropRates: FunctionComponent<Props> = ({
    cropRates,
    testId = TEST_ID,
    title
}) => (
    <VerticalContainer className={styles.cropRatesSection} testId={testId}>
        <BodyText className={styles.sectionTitle} text={title} />

        {cropRates.map(({ crop, maxRate, minRate, ratePerUnit, rateUnit }) => {
            const rateText =
                minRate !== null && maxRate !== null
                    ? `${minRate} - ${maxRate} ${rateUnit ?? ''}/${ratePerUnit ?? ''}`
                    : '-';

            return <CaptionText key={crop} text={`${crop}: ${rateText}`} />;
        })}
    </VerticalContainer>
);

export default ChemicalDetailCropRates;
